import { render, staticRenderFns } from "./VisualPagination.vue?vue&type=template&id=7c5b0476&scoped=true"
import script from "./VisualPagination.vue?vue&type=script&lang=js"
export * from "./VisualPagination.vue?vue&type=script&lang=js"
import style0 from "./VisualPagination.vue?vue&type=style&index=0&id=7c5b0476&prod&lang=scss&scoped=true"
import style1 from "./VisualPagination.vue?vue&type=style&index=1&id=7c5b0476&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5b0476",
  null
  
)

export default component.exports